(async () => {
  const routing = JSON.parse(document.getElementById('whatsapp-routing').textContent);
  let target = routing.defaultUrl;
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 1500);

  try {
    const response = await fetch('/cdn-cgi/trace', {
      cache: 'no-store',
      credentials: 'omit',
      signal: controller.signal,
    });
    if (!response.ok) {
      throw new Error(`WhatsApp GeoIP request failed: HTTP ${response.status}`);
    }
    const trace = await response.text();
    const country = /^loc=([A-Z]{2})\r?$/m.exec(trace)?.[1];
    if (!country) {
      throw new Error('WhatsApp GeoIP response is missing a country code');
    }
    target = routing.countries[country] || routing.defaultUrl;
  } catch (error) {
    // Contact must remain available when GeoIP is unavailable, including local previews.
    console.warn('WhatsApp GeoIP unavailable; using the default account.', error);
  } finally {
    clearTimeout(timeout);
  }

  window.location.replace(target);
})();
